module.exports = {"610626001":"吴起街道","610626101":"铁边城镇","610626102":"周湾镇","610626103":"白豹镇","610626104":"长官庙镇","610626105":"长城镇","610626106":"五谷城镇","610626107":"吴仓堡镇","610626108":"庙沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610626.json
// module id = 2631
// module chunks = 0